import ExecuteAxios from "Components/ExecuteAxios/ExecuteAxios";
import InputField from "Components/Input/InputField";
import Panel from "Components/Panel/Panel";
import React, { useEffect, useState } from "react";
import RightArrow from "../../../../../Components/SideBar/assets/icons/right-arrow.png"
import TextAreaField from "Components/TextAreaField/TextAreaField";
import ApplyAttributes from "Components/ApplyAttributes/ApplyAttributes";
import AutomaticallyListedAttributes from "Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes";
import ResetVariables from "Components/ResetVariables/ResetVariables";

const SalaryDayPanelDetail = ({
    itemInValidation,
    costDayIdSelecteds,
    onUpdateCostDayIdSelecteds,
    updating,
    dsItem,
    dsMonth,
    onUpdateInsertSalary,
    setUpdating,
    showNewSalaryMonthPanel,
    handleClose,
    getButtonToShowSubtitles,
    panelListCostDay,
    updatePanelCostSpreadsheet,
    onUpdatePanelCostSpreadsheet,
    onUpdateReloadSalaryBenefitsCost
}) => {
    const [idSalarySelected, setIdSalarySelected] = useState(null)
    const [employeeName, setEmployeeName] = useState(null)
    const [realSalary, setRealSalary] = useState(null)
    const [expectedSalary, setExpectedSalary] = useState(null)
    const [overtime, setOvertime] = useState(null)
    const [fgts, setFgts] = useState(null)
    const [inss, setInss] = useState(null)
    const [thirteenthSalary, setThirteenthSalary] = useState(null)
    const [vacation, setVacation] = useState(null)
    const [oneHalfVacation, setOneHalfVacation] = useState(null)
    const [total, setTotal] = useState(null)
    const [updateDate, setUpdateDate] = useState(null)
    const [username, setUsername] = useState(null)
    const [isAutomaticCalculation, setIsAutomaticCalculation] = useState(null)

    const [salaryDayListDetail, setSalaryDayListDetail] = useState(null);

    const attributeList = [
        { name: "id", value: idSalarySelected, setter: setIdSalarySelected },
        { name: "employeeName", value: employeeName, setter: setEmployeeName },
        { name: "salaryValue", value: realSalary, setter: setRealSalary },
        { name: "expectedValue", value: expectedSalary, setter: setExpectedSalary },
        { name: "overtime", value: overtime, setter: setOvertime },
        { name: "fgts", value: fgts, setter: setFgts },
        { name: "inss", value: inss, setter: setInss },
        { name: "thirteenthSalary", value: thirteenthSalary, setter: setThirteenthSalary },
        { name: "vacation", value: vacation, setter: setVacation },
        { name: "oneHalfVacation", value: oneHalfVacation, setter: setOneHalfVacation },
        { name: "total", value: total, setter: setTotal },
        { name: "dtUpdate", value: updateDate, setter: setUpdateDate },
        { name: "username", value: username, setter: setUsername },
        { name: "isAutomaticCalculation", value: isAutomaticCalculation, setter: setIsAutomaticCalculation }
    ];

    const setAttributesPanelDetail = async (costDayIdSelected) => {
        const parameters = {
            id: costDayIdSelected,
            itemId: itemInValidation.key
        }
        const salaryMonth = await ExecuteAxios.api('get', `/salary-month/salary-month-by-id/`, { params: parameters })
        setSalaryDayListDetail(salaryMonth)
        if (salaryMonth) {
            ApplyAttributes.applyAttributes(salaryMonth, attributeList)
        }

        if (!costDayIdSelected || costDayIdSelected.length === 0) {
            ResetVariables.resetVariables(attributeList);
        }
    };

    useEffect(() => {
        if (costDayIdSelecteds && costDayIdSelecteds.length === 1) {
            setAttributesPanelDetail(costDayIdSelecteds[0]);
        } else {
            setAttributesPanelDetail(null)
        }
    }, [costDayIdSelecteds, updating]);

    async function putCostDay() {
        if (costDayIdSelecteds && costDayIdSelecteds.length === 1) {
            const response = await ExecuteAxios.api('put', `/salary-month/update-salary-month/`, {
                id: idSalarySelected,
                expectedSalary: expectedSalary,
                salary: realSalary,
                overtime: overtime,
                isAutomaticCalculation: isAutomaticCalculation
            });

            if (response) {
                onUpdatePanelCostSpreadsheet(true)
                onUpdateReloadSalaryBenefitsCost(true)
            }

            return response;
        }
    }

    async function deleteSalaryMonth() {
        if (costDayIdSelecteds) {
            const parameters = { id: costDayIdSelecteds.join(",") };
            const response = await ExecuteAxios.api('delete', `/salary-month/`, { params: parameters });

            if (response) {

                onUpdatePanelCostSpreadsheet(true)
                onUpdateReloadSalaryBenefitsCost(true)
                onUpdateCostDayIdSelecteds([])
            }
            return response
        }
    }

    const costDayStyle = {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '95%',
        zIndex: '0',
        overflow: 'hidden'
    }

    function getContentPanel() {
        if (!updating) {
            return panelListCostDay
        } else {
            return (
                <AutomaticallyListedAttributes
                    list={salaryDayListDetail}
                    attributeList={attributeList}
                    readOnlyAttributes={!updating}
                />
            )
        }
    }

    return (
        <Panel titlePage={dsMonth + ' - ' + dsItem}
            style={costDayStyle}
            canViewCRUD={true}
            updating={updating}
            setInserting={onUpdateInsertSalary}
            setUpdating={setUpdating}
            inserting={false}
            updateNameButton={(itemInValidation.key === 4) ? 'Editar' : 'Visualizar'}
            enableNewRecord={[4].includes(itemInValidation.key)}
            canNewRecord={(!showNewSalaryMonthPanel && !updating)}
            canDelete={costDayIdSelecteds && costDayIdSelecteds.length > 0}
            deleteFunction={deleteSalaryMonth}
            enableDelete={true}
            recordsSelected={costDayIdSelecteds}
            enableEdit={true}
            canEdit={costDayIdSelecteds && costDayIdSelecteds.length === 1}
            putFunction={putCostDay}
            componentRightButtons={(updating || showNewSalaryMonthPanel) ? null :
                <button
                    style={{
                        backgroundImage: `url(${RightArrow})`,
                        backgroundSize: '30px 30px',
                        width: '35px',
                        height: '35px',
                        backgroundRepeat: 'no-repeat',
                        backgroundColor: 'transparent',
                        border: 'none',
                        cursor: 'pointer',
                        alignItems: 'center'
                    }}
                    onClick={handleClose}
                />
            }
            subtitlesPanelBottom={getButtonToShowSubtitles()}
            dataListedAttributes={salaryDayListDetail}
            attributeList={attributeList}
        >
            {getContentPanel()}
        </Panel>
    )
}

export default SalaryDayPanelDetail;